import { useSearchParams } from 'react-router-dom'

import { ExtendVisitorParking } from './extend-visitor-parking'
import { VisitorParking } from './visitor-parking'
import { VISITOR_PARKING_TICKET_NUMBER_URL_KEY } from './visitor-parking.constants'

const VisitorParkingPage = () => {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get(VISITOR_PARKING_TICKET_NUMBER_URL_KEY)

  // Note: If the sessionId is present in the URL it means the visitor already has a session
  // In such case the session can be extended
  if (sessionId) {
    return <ExtendVisitorParking />
  }

  return <VisitorParking />
}

export { VisitorParkingPage }
